/**
 * Constantes pour les noms d'evenements de tracking
 * Centralise tous les noms pour eviter les typos et faciliter les recherches
 */

export const TRACKING_EVENTS = {
  // Navigation
  PAGE_VIEW: 'page_view',
  MODULE_ACCESS: 'module_access',

  // Authentification
  LOGIN_SUCCESS: 'login_success',
  LOGIN_FAILED: 'login_failed',
  LOGOUT: 'logout',
  SESSION_RESTORED: 'session_restored',

  // Prestations
  PRESTATION_CREATED: 'prestation_created',
  PRESTATION_UPDATED: 'prestation_updated',
  PRESTATION_DELETED: 'prestation_deleted',
  PRESTATION_VIEWED: 'prestation_viewed',
  PRESTATION_LOCKED: 'prestation_locked',
  PRESTATION_UNLOCKED: 'prestation_unlocked',
  PRESTATION_MOVED: 'prestation_moved',

  // Utilisateurs
  USER_CREATED: 'user_created',
  USER_UPDATED: 'user_updated',
  USER_DELETED: 'user_deleted',
  USER_VIEWED: 'user.viewed',

  // Groupes
  GROUP_CREATED: 'group_created',
  GROUP_UPDATED: 'group_updated',
  GROUP_DELETED: 'group_deleted',
  GROUP_VIEWED: 'group.viewed',
  GROUP_MEMBER_ADDED: 'group_member_added',
  GROUP_MEMBER_REMOVED: 'group_member_removed',

  // Clients
  CLIENT_CREATED: 'client_created',
  CLIENT_UPDATED: 'client_updated',
  CLIENT_DELETED: 'client_deleted',
  CLIENT_VIEWED: 'client.viewed',

  // Lieux
  LOCATION_VIEWED: 'location.viewed',

  // Disponibilites
  AVAILABILITY_SET: 'availability_set',
  AVAILABILITY_UPDATED: 'availability_updated',
  AVAILABILITY_REMOVED: 'availability_removed',

  // Collaboration
  MODAL_LOCK_ACQUIRED: 'modal_lock_acquired',
  MODAL_LOCK_RELEASED: 'modal_lock_released',
  MODAL_LOCK_DENIED: 'modal_lock_denied',
  DRAG_MODE_ACQUIRED: 'drag_mode_acquired',
  DRAG_MODE_RELEASED: 'drag_mode_released',

  // Filtres et recherche
  FILTER_APPLIED: 'filter_applied',
  SEARCH_PERFORMED: 'search_performed',

  // Exports
  EXPORT_CSV: 'export_csv',
  EXPORT_PDF: 'export_pdf',

  // Erreurs
  API_ERROR: 'api_error',
  JS_ERROR: 'js_error',

  // Audit generique
  ENTITY_CREATED: 'entity_created',
  ENTITY_UPDATED: 'entity_updated',
  ENTITY_DELETED: 'entity_deleted'
};

/**
 * Categories d'evenements
 */
export const TRACKING_CATEGORIES = {
  ANALYTICS: 'analytics',  // Comportement utilisateur
  AUDIT: 'audit',          // Tracabilite des modifications
  PRESENCE: 'presence',    // Utilisateurs connectes (Phase 2)
  PERF: 'perf'             // Performance et erreurs (Phase 3)
};

/**
 * Types d'evenements
 */
export const EVENT_TYPES = {
  PAGE_VIEW: 'page_view',
  ACTION: 'action',
  ENTITY_UPDATE: 'entity_update',
  ERROR: 'error',
  PERFORMANCE: 'performance'
};

/**
 * Modules de l'application
 */
export const MODULES = {
  DASHBOARD: 'dashboard',
  USERS: 'users',
  GROUPS: 'groups',
  CLIENTS: 'clients',
  LOCATIONS: 'locations',
  HR: 'hr',
  WORKSHEETS: 'worksheets',
  PLANNING: 'planning',
  HOLIDAYS: 'holidays',
  PERMISSIONS: 'permissions',
  EMAIL_TEMPLATES: 'email-templates',
  ANALYTICS: 'analytics'  // Phase 4
};

export default TRACKING_EVENTS;
